import { useQuery, useQueryClient } from "@tanstack/react-query";
import SharedScreenAPI from "../../api/api/SharedScreenAPI";
import { atomWithStorage } from "jotai/utils";
import { useAtomValue, useSetAtom } from "jotai";
import { useMemo } from "react";
import { setSchemaAtom } from "../../atoms/GlobalAtoms";

export const pagePasswordAtom = atomWithStorage<Record<string, string>>(
  "page-passwords",
  {},
  undefined,
  { getOnInit: true }
);

export default function useSharedDocument(
  tenantID: string,
  sharedDocID: string
) {
  const pagePasswords = useAtomValue(pagePasswordAtom);
  const setSchema = useSetAtom(setSchemaAtom);
  const client = useQueryClient();

  const password = useMemo(() => {
    if (!tenantID || !sharedDocID) return null;

    return pagePasswords[`${tenantID}-${sharedDocID}`] || null;
  }, [pagePasswords, tenantID, sharedDocID]);

  const sharedDocument = useQuery({
    queryKey: ["shared-document", sharedDocID],
    queryFn: () => {
      return SharedScreenAPI.getSharedDoc(
        tenantID,
        sharedDocID,
        password || ""
      ).then((data) => {
        if (!data.data.data.success) return data.data.data;

        if (data.data.data.document) {
          client.setQueryData(
            [tenantID, "record", "Documents", data.data.data.document?._id],
            data.data.data.document
          );
        }

        setSchema(data.data.data.schema);

        return data.data.data;
      });
    },
    enabled: !!tenantID && !!sharedDocID,
    staleTime: Infinity,
  });

  return {
    sharedDocument: sharedDocument.data,
    documentLoading: sharedDocument.isLoading,
  };
}
